import { useEffect, useState } from 'react';
import { IS_B2B } from '@/domains/core/settings/constants';
import { formatBr, formatRemoveBr } from '@/domains/proB2BAnimation/utils/translate/formatters';
import messages from '../translations';
import styles from './useAvailabilityTextContactService.module.scss';
interface Props {
  isPreSales: boolean;
  splitWeekend?: boolean; // split saturday info in a new line
}
export function useAvailabilityTextContactService({
  isPreSales,
  splitWeekend
}: Props) {
  const [desktopText, setDesktopText] = useState<string | string[]>('');
  const [mobileText, setMobileText] = useState<string | string[]>('');
  const [desktopTestId, setDesktopTestId] = useState<string>('');
  const [mobileTestId, setMobileTestId] = useState<string>('');
  useEffect(() => {
    const presalesKey = isPreSales ? 'PS' : 'AS';
    const isB2BKey = IS_B2B ? 'B2B' : 'B2C';
    const isMobilekey = {
      MOBILE: 'Mobile',
      DESKTOP: 'Desktop'
    };
    const getKey = (isMobile: string) => `availability${isB2BKey}${isMobile}${presalesKey}`;
    const getTesId = (isMobile: string) => `availability-${isB2BKey}-${isMobile}-${presalesKey}`;
    const desktopMessage = messages[getKey(isMobilekey.DESKTOP)];
    const mobileMessage = messages[getKey(isMobilekey.MOBILE)];
    setDesktopText(splitWeekend ? desktopMessage.format<string>(formatBr()) : desktopMessage.format<string>(formatRemoveBr()));
    setMobileText(splitWeekend ? mobileMessage.format<string>(formatBr()) : mobileMessage.format<string>(formatRemoveBr()));
    setDesktopTestId(getTesId(isMobilekey.DESKTOP));
    setMobileTestId(getTesId(isMobilekey.MOBILE));
  }, [isPreSales, splitWeekend]);
  return <span className={styles.contactTextWrapper}>
      <span className={styles.desktop} data-testid={desktopTestId}>
        {desktopText}
      </span>
      <span className={styles.mobile} data-testid={mobileTestId}>
        {mobileText}
      </span>
    </span>;
}